import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import linkpage from './LinkPage.module.css';
import '@flaticon/flaticon-uicons/css/all/all.css';
import { ref, onValue } from 'firebase/database';
import { database } from '../../firebase';

const LinkPage = () => {
    const { sessionId } = useParams();
    const [data, setData] = useState([]);
    const [title, setTitle] = useState('Link and Text Entries');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const sessionRef = ref(database, `Sessions/${sessionId}`);
        onValue(sessionRef, (snapshot) => {
            const sessionData = snapshot.val();
            if (sessionData && sessionData.Content) {
                setTitle(sessionData.Name || 'Link and Text Entries');
                const contentArray = Object.keys(sessionData.Content).map(key => ({
                    id: key,
                    ...sessionData.Content[key]
                }));
                setData(contentArray);
            } else {
                setData([]);
            }
            setLoading(false);
        });
    }, [sessionId]);

    const handleOpen = (url) => {
        window.open(url, '_blank'); // Open link in a new tab
    };

    const handleCopy = (text) => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(() => {
                console.log('Text copied to clipboard');
            }).catch(err => {
                console.error('Failed to copy text: ', err);
            });
        } else {
            console.error('Clipboard API not supported');
            // Fallback: Use a textarea element to copy text
            const textArea = document.createElement('textarea');
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                console.log('Text copied to clipboard');
            } catch (err) {
                console.error('Failed to copy text: ', err);
            }
            document.body.removeChild(textArea);
        }
    };
    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div className={linkpage['link-page-container']}>
            <h2>{title}</h2>
            <div className={linkpage['link-table']}>
                {data.map((item) => (
                    <div key={item.id} className={linkpage['link-card']}>
                        <div className={linkpage['link-title']}>{item.title}</div>
                        <div className={linkpage['link-body']}>{item.content}</div>
                        <div className={linkpage['link-actions']}>
                            {item.content.startsWith('http') ? (
                                <>
                                    <div className={linkpage['square-button']} onClick={() => handleCopy(item.content)}
                                         title="Copy Link">
                                        <i className="fi fi-rr-copy-alt"></i>
                                    </div>
                                    <div className={linkpage['square-button']} onClick={() => handleOpen(item.content)}
                                         title="Open Link">
                                        <i className="fi fi-sr-folder-open"></i>
                                    </div>
                                </>
                            ) : (
                                <div className={linkpage['square-button']} onClick={() => handleCopy(item.content)} title="Copy">
                                    <i className="fi fi-rr-copy-alt"></i>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LinkPage;